import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      margin: [0, 35, 94, 35],
      backgroundColor: 'var(--x-bg-5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      borderRadius: 20,
      paddingBottom: 40,

      [mediaQuery(breakpoints.tablet)]: {
        margin: [32, 24],
      },
    },
    subtitle: {
      fontSize: 13,
      color: 'var(--x-text-color-2)',
      marginTop: 10,
    },
  }),
  {
    name: 'ReviewSnippet',
  },
);

export default useStyles;
